import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'id',
     field: FIELDS.ID,
     title: 'BOM No',
     label: 'BOM No',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactFullName',
     field: FIELDS.CONTACT_FULL_NAME,
     title: 'Contact',
     label: 'Contact',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'requirementDate',
     field: FIELDS.REQUIREMENT_DATE,
     title: 'BOM Date',
     label: 'BOM Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'requirementNumber',
     field: FIELDS.REQUIREMENT_NUMBER,
     title: 'Cust BOM No',
     label: 'Cust BOM No',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'referalSourceName',
     field: FIELDS.REFERAL_SOURCE_NAME,
     title: 'Referal Source',
     label: 'Referal Source',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'currencyTypeName',
     field: FIELDS.CURRENCY_TYPE_NAME,
     title: 'Currency',
     label: 'Currency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'exchangeRate',
     field: FIELDS.EXCHANGE_RATE,
     title: 'Exch Rate',
     label: 'Exch Rate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'salesPersonUserFullName',
     field: FIELDS.SALES_PERSON_USER_FULL_NAME,
     title: 'Sales Person',
     label: 'Sales Person',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactFirstName',
     field: FIELDS.CONTACT_FIRST_NAME,
     title: 'Contact First Name',
     label: 'Contact First Name',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'contactLastName',
     field: FIELDS.CONTACT_LAST_NAME,
     title: 'Contact Last Name',
     label: 'Contact Last Name',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'currencySymbol',
     field: FIELDS.CURRENCY_SYMBOL,
     title: 'CurrencySymbol',
     label: 'CurrencySymbol',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'requirementFax',
     field: FIELDS.REQUIREMENT_FAX,
     title: 'Fax',
     label: 'Fax',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'customerNote',
     field: FIELDS.CUSTOMER_NOTE,
     title: 'Customer Note',
     label: 'Customer Note',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
